<mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
    <mat-tab>
        <ng-template mat-tab-label>
            <span matBadge="{{testStepNum}}" [matBadgeHidden]="testStepNum === 0" matBadgeOverlap="false" class="tab_step_badge">Test's steps</span>
        </ng-template>
        <dpi-test-step-list (listSizeChanged)="setTestStepNum($event)"> </dpi-test-step-list>
    </mat-tab>
    <mat-tab label="Test Details">
        <dpi-test-details> </dpi-test-details>
    </mat-tab>
    <mat-tab>
        <ng-template mat-tab-label>
            <span matBadge="{{pictureNum}}" [matBadgeHidden]="pictureNum === 0" matBadgeOverlap="false" class="tab_test_badge">Pictures</span>
        </ng-template>
        <dpi-test-picture (listSizeChanged)="setPictureNum($event)"> </dpi-test-picture>
    </mat-tab>
    <mat-tab>
        <ng-template mat-tab-label>
            <span matBadge="{{recommendationNum}}" [matBadgeHidden]="recommendationNum === 0" matBadgeOverlap="false" class="tab_recommendation_badge">Recommendation</span>
        </ng-template>
        <dpi-test-recommendation (listSizeChanged)="setRecommendationNum($event)"></dpi-test-recommendation>
    </mat-tab>
</mat-tab-group>
